module.exports = __webpack_public_path__ + "img/btn-app-store-170.598bc8bd.png";